import React from 'react';
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom'

import Home from './components/home'
import TagHandler from './components/tag'
import StickerHandler from './components/sticker'
import BundleHandler from './components/bundle'
import NotificationHandler from 'components/handlers/notification/NotificationHandler'

const App = () => (
	<div>
		<Router>
			<Switch>
				<Route path="/stickers/:stickerId" component={StickerHandler} /> {/* requires redirection from TagHandler! */}
				<Route path="/bundles/:bundleId" component={BundleHandler} /> {/* requires redirection from TagHandler! */}
				<Route path="/:bundleNo(\w{6})/:tag(\w{9})" exact component={TagHandler} /> {/* match [a-zA-Z0-9_] of length 9 for web tokens */}
				<Route path="/:bundleNo(\w{6})/:tag(\w{16})" exact component={TagHandler} /> {/* match [a-zA-Z0-9_] of length 16 for nfc and qr */}
				<Route path="/:bundleNo(\w{6})/stickers/:stickerId" component={StickerHandler} /> {/* requires redirection from TagHandler! */}
				<Route path="/:tag(demo)" exact component={TagHandler} /> {/* match [a-zA-Z0-9_] of length 16 for demo tag */}
				<Route path="/:tag(\w{9})" exact component={TagHandler} /> {/* match [a-zA-Z0-9_] of length 9 for web tokens */}
				<Route path="/:tag(\w{16})" exact component={TagHandler} /> {/* match [a-zA-Z0-9_] of length 16 for nfc and qr */}
				<Route path="/home" component={Home} />
				<Redirect to="/home" />
			</Switch>
		</Router>
		<NotificationHandler />
	</div>
);

export default App;


// WEBPACK FOOTER //
// ./src/App.jsx